import React from 'react';
import TutorialTop from './components/tutorial/TutorialTop';

function Tutorial() {
  return <TutorialTop />;
}

export default Tutorial;
